module.exports = __webpack_public_path__ + "static/media/notification.png.427bbb88.png";